"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const LayoutVisualizerBlock_1 = require("./LayoutVisualizerBlock");
class LayoutVisualizerBlocks extends react_1.default.Component {
    render() {
        const { blocks, isChild, isRepeat } = this.props;
        return (react_1.default.createElement(react_1.default.Fragment, null, blocks.map((b, key) => {
            return (react_1.default.createElement(LayoutVisualizerBlock_1.LayoutVisualizerBlock, { block: b, key: key, isChild: isChild, isRepeat: isRepeat }));
        })));
    }
}
exports.LayoutVisualizerBlocks = LayoutVisualizerBlocks;
//# sourceMappingURL=LayoutVisualizerBlocks.js.map